import { render, staticRenderFns } from "./updateXminfo.vue?vue&type=template&id=5d89fd9e&scoped=true&"
import script from "./updateXminfo.vue?vue&type=script&lang=js&"
export * from "./updateXminfo.vue?vue&type=script&lang=js&"
import style0 from "./updateXminfo.vue?vue&type=style&index=0&id=5d89fd9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d89fd9e",
  null
  
)

export default component.exports